import ApiAgent, { handleError } from '@/common/agent/ApiAgent';
import { toDateText } from '@/common/util/formatUtil';
import { CampaignReadBase } from '../model/CampaignApiTypes';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';

export const queryKey = (dates: [Date, Date], createDepartmentIds?: number[]) => {
  const [startDateText, endDateText] = dates.map((date) => toDateText(date, 'yyyyMMdd'));
  return ['campaignList', startDateText, endDateText, createDepartmentIds?.join(',')] as const;
};

export const useGetCampaignList = (
  dates: [Date, Date],
  createDepartmentIds?: number[],
  options?: Omit<UseQueryOptions<CampaignReadBase[]>, 'queryKey' | 'queryFn'>,
) => {
  return useQuery<CampaignReadBase[]>({
    queryKey: queryKey(dates, createDepartmentIds),
    queryFn: async () => {
      try {
        const [startDateText, endDateText] = dates.map((date) => toDateText(date, 'yyyyMMdd'));
        const response = await ApiAgent.get<CampaignReadBase[]>('/campaign-management/campaigns', {
          params: {
            start_date: startDateText,
            end_date: endDateText,
            create_department_ids: createDepartmentIds,
          },
        });
        return response.data;
      } catch (error) {
        handleError(error);
        throw error;
      }
    },
    ...options,
  });
};
